import React from "react";
import '../App.css';
import Story from "../components/Story";

export default function Intro() {

    const SM = {
        ONE: {
            bgImg: "url(/kueh-shop.jpg)",
            speechText: "Another day at the kueh shop, waiting for customers to arrive.",
            speechFontStyle: "not-italic",
            speechTextColor: "text-black",
            speechDivColor: "bg-white",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#000000",
            step() { return SM.TWO }
        },
        TWO: {
            bgImg: "url(/kueh-shop.jpg)",
            speechText: "With the CPF Service Centre nearby, most of them usually come after running errands there.",
            speechFontStyle: "not-italic",
            speechTextColor: "text-black",
            speechDivColor: "bg-white",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#000000",
            step() { return SM.THREE }
        },
        THREE: {
            bgImg: "url(/kueh-shop-transparent.jpg)",
            speechText: "You overhear your customers having a conversation.",
            speechFontStyle: "italic",
            speechTextColor: "text-white",
            speechDivColor: "bg-teal-900",
            nameText: "",
            nameAlign:"hidden",
            arrowColour:"#ffffff",
            characters: [
                {img: "/characters/customer-1.png",  active: true}, 
                {img: "/characters/customer-2.png",  active: true}
            ],
            step() { return SM.FOUR }
        },
        FOUR: {
            bgImg: "url(/kueh-shop-transparent.jpg)",
            speechText: "I have to go to CPF Service Centre after this to make a top up to my retirement account... ",
            speechFontStyle: "not-italic",
            speechTextColor: "text-black",
            speechDivColor: "bg-white",
            nameText: "Customer 1",
            nameAlign:"left-10",
            arrowColour:"#000000",
            characters:[
                {img: "/characters/customer-1.png",  active: true}, 
                {img: "/characters/customer-2.png",  active: false}
            ],
            step() { return SM.FIVE }
        },
        FIVE: {
            bgImg: "url(/kueh-shop-transparent.jpg)",
            speechText: "Guess I'll be late for our lunch gathering later.",
            speechFontStyle: "not-italic",
            speechTextColor: "text-black",
            speechDivColor: "bg-white",
            nameText: "Customer 1",
            nameAlign:"left-10",
            arrowColour:"#000000",
            characters:[
                {img: "/characters/customer-1.png",  active: true}, 
                {img: "/characters/customer-2.png",  active: false}
            ],
            step() { return SM.SIX }
        },
        SIX: {
            bgImg: "url(/kueh-shop-transparent.jpg)",
            speechText: "Ah, I understand. CPF matters need to go Service Centre to resolve one.",
            speechFontStyle: "not-italic",
            speechTextColor: "text-black",
            speechDivColor: "bg-white",
            nameText: "Customer 2",
            nameAlign:"right-10",
            arrowColour:"#000000",
            characters:[
                {img: "/characters/customer-1.png",  active: false}, 
                {img: "/characters/customer-2.png",  active: true}
            ],
            step() { return SM.SEVEN }
        },
        SEVEN: {
            bgImg: "url(/kueh-shop-transparent.jpg)",
            speechText: "Hmm... that’s not technically true. Many CPF services have gone online now.",
            speechFontStyle: "italic",
            speechTextColor: "text-white",
            speechDivColor: "bg-teal-900",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#ffffff",
            characters:[
                {img: "/characters/customer-1.png",  active: false}, 
                {img: "/characters/customer-2.png",  active: false}
            ],
            step() { return SM.EIGHT }
        },
        EIGHT: {
            bgImg: "url(/service-centre-transparent.jpg)",
            speechText: "I used to go to the CPF Service Centre all the time to resolve my queries and transactions...",
            speechFontStyle: "italic",
            speechTextColor: "text-white",
            speechDivColor: "bg-teal-900",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#ffffff",
            step() { return SM.NINE }
        },
        NINE: {
            bgImg: "url(/home.jpg)",
            speechText: "But recently, my grandson showed me I could actually do them on the CPF website.",
            speechFontStyle: "italic",
            speechTextColor: "text-white",
            speechDivColor: "bg-teal-900",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#ffffff",
            characters:[
                {img: "/hand.png",  active: true}
            ],
            step() { return SM.TEN }
        },
        TEN: {
            bgImg: "url(/home.jpg)",
            speechText: "Since then, it’s been ages since I went to the Service Centre!",
            speechFontStyle: "italic",
            speechTextColor: "text-white",
            speechDivColor: "bg-teal-900",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#ffffff",
            characters:[
                {img: "/hand.png",  active: true}
            ],
            step() { return SM.ELEVEN }
        },
        ELEVEN: {
            bgImg: "url(/home.jpg)",
            speechText: "It’s easy to use the CPF website, all in the comfort of my home.",
            speechFontStyle: "italic",
            speechTextColor: "text-white",
            speechDivColor: "bg-teal-900",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#ffffff",
            characters:[
                {img: "/hand.png",  active: true}
            ],
            step() { return SM.TWELVE }
        },
        TWELVE: {
            bgImg: "url(/kueh-shop-transparent.jpg)",
            speechText: "Maybe I can show my customers how to use the CPF e-services too!",
            speechFontStyle: "italic",
            speechTextColor: "text-white",
            speechDivColor: "bg-teal-900",
            nameText: "You",
            nameAlign:"right-10",
            arrowColour:"#ffffff",
            characters:[
                {img: "/characters/customer-1.png",  active: false},
                {img: "/characters/customer-2.png",  active: false},
            ],
            fin: true
        }
    }
    

    return (
        <Story SM={ SM } complete="/tasks"/>
        
    );
}